var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionLocked = function SvgActionLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7132 6.66667H14.7608V4.7619C14.7608 2.13333 12.6275 0 9.99893 0C7.37036 0 5.23703 2.13333 5.23703 4.7619V6.66667H4.28464C3.23703 6.66667 2.37988 7.52381 2.37988 8.57143V18.0952C2.37988 19.1429 3.23703 20 4.28464 20H15.7132C16.7608 20 17.618 19.1429 17.618 18.0952V8.57143C17.618 7.52381 16.7608 6.66667 15.7132 6.66667ZM9.99893 15.2381C8.95131 15.2381 8.09417 14.381 8.09417 13.3333C8.09417 12.2857 8.95131 11.4286 9.99893 11.4286C11.0465 11.4286 11.9037 12.2857 11.9037 13.3333C11.9037 14.381 11.0465 15.2381 9.99893 15.2381ZM12.9513 6.66667H7.04655V4.7619C7.04655 3.13333 8.37036 1.80952 9.99893 1.80952C11.6275 1.80952 12.9513 3.13333 12.9513 4.7619V6.66667Z",
    fill: "#EB5757"
  })));
};
export { SvgActionLocked as ReactComponent };
export default __webpack_public_path__ + "action-locked.svg";